import { useContractRead } from 'wagmi'
import { useAccount } from 'wagmi'
import { ADDRESSES, CONFIG } from '../config'
import { Abi } from 'viem'

interface UseAllowanceProps {
  token: `0x${string}`
  spender?: `0x${string}`
  enabled?: boolean
}

export function useAllowance({ token, spender, enabled = true }: UseAllowanceProps) {
  const { address } = useAccount()

  const { data, isLoading, error } = useContractRead({
    address: token,
    abi: CONFIG.ERC20_ABI.abi as unknown as Abi,
    functionName: 'allowance',
    args: [address as `0x${string}`, spender as `0x${string}`],
    enabled: enabled && !!address && !!spender,
  })

  return {
    data,
    isLoading,
    error
  }
} 